// extracted by mini-css-extract-plugin
export default {"container":"Testimonials-module--container--2-LkH","slide":"Testimonials-module--slide--1vrRn","next":"Testimonials-module--next--1Irg-","prev":"Testimonials-module--prev--1iqmS"};